class GulmoharMobileDrawer extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      if (event.target.closest('[data-gmd-open]')) {
        this.open();
        return;
      }

      const toggle = event.target.closest('[data-gmd-toggle]');
      if (toggle) {
        this.toggleAccordion(toggle);
        return;
      }

      if (event.target.closest('[data-gmd-close]')) {
        this.close();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.classList.contains('is-open')) {
        this.close();
      }
    });
  }

  toggleAccordion(toggle) {
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    const sublist = document.getElementById(toggle.getAttribute('aria-controls'));
    toggle.setAttribute('aria-expanded', String(!expanded));
    if (sublist) sublist.classList.toggle('is-open', !expanded);
  }

  open() {
    this.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }

  close() {
    this.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }
}

customElements.define('gulmohar-mobile-drawer', GulmoharMobileDrawer);
